import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ConsoleErrorService } from '../../services/console-error.service';
import { ErrorListModalComponent } from '../error-list/error-list-modal.component';

/**
 * Standalone Fehler-Badge-Indikator.
 * Zeigt Fehleranzahl mit Badge:
 * - Rot: Alle Konsolen-Fehler (für Entwickler)
 * - Orange: Unbekannte Fehler (für Projektmanager)
 */
@Component({
	selector: 'wd-error-badge',
	standalone: true,
	imports: [NgbTooltipModule],
	template: `
		@if (mode === 'all' && ces.errorCount() > 0) {
			<button class="btn btn-status error-badge-btn" placement="start"
					ngbTooltip="Konsolen-Fehler (Klicken zum Zurücksetzen)" tooltipClass="custom-tooltip-class"
					(click)="ces.clear()">
				<i class="bi bi-bug-fill" style="color: red"></i>
				<span class="badge rounded-pill bg-danger error-count">{{ ces.errorCount() > 99 ? '99+' : ces.errorCount() }}</span>
			</button>
		}
		@if (mode === 'unknown' && ces.unknownErrorCount() > 0) {
			<button class="btn btn-status error-badge-btn" placement="start"
					ngbTooltip="Fehler aufgetreten (Klicken für Details)" tooltipClass="custom-tooltip-class"
					(click)="showErrorList()">
				<i class="bi bi-bug-fill" style="color: orange"></i>
				<span class="badge rounded-pill bg-warning error-count">{{ ces.unknownErrorCount() > 99 ? '99+' : ces.unknownErrorCount() }}</span>
			</button>
		}
	`,
	styles: [`
		.btn-status { padding-left: 0.1rem; border-style: none; }
		.error-badge-btn { display: flex; align-items: center; gap: 0.2rem; }
		.error-badge-btn .error-count { font-size: 0.65rem; padding: 0.15em 0.4em; }
	`]
})
export class WdErrorBadgeComponent {
	ces = inject(ConsoleErrorService);
	private modalService = inject(NgbModal);

	/** 'all' = alle Konsolen-Fehler (Entwickler), 'unknown' = unbekannte Fehler (Manager) */
	@Input() mode: 'all' | 'unknown' = 'unknown';

	@Output() errorsCleared = new EventEmitter<void>();

	async showErrorList(): Promise<void> {
		const modalRef = this.modalService.open(ErrorListModalComponent, {
			centered: true,
			size: 'lg'
		});
		const component = modalRef.componentInstance as ErrorListModalComponent;
		component.title = 'Fehler aufgetreten';
		component.errors = this.ces.unknownErrors();
		try {
			await modalRef.result;
		} catch { }
		this.ces.clearUnknown();
	}
}
